// theme.js or theme.ts
import { createTheme } from '@mui/material/styles';
import { Theme as SharedTheme } from '@tis/shared-tis-ui';

const theme = createTheme(SharedTheme, {
  // Overrides that will be deep merged
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }: { ownerState: any; theme: any }) => {
          // Get the original styles from the shared theme
          const originalRootFunction =
            SharedTheme.components?.MuiButton?.styleOverrides?.root;
          let originalStyles: Record<string, any> = {};

          // Call the original function if it exists and handle the result
          if (typeof originalRootFunction === 'function') {
            const result = originalRootFunction({ ownerState, theme });

            if (
              result &&
              typeof result === 'object' &&
              !Array.isArray(result)
            ) {
              originalStyles = result as Record<string, any>;
            }
          }

          // Return merged styles with override
          return {
            ...originalStyles,
            borderRadius: 0,
          };
        },
      },
    },
  },
});

export default theme;
